export default __webpack_public_path__ + "assets/bolivia-flag.png";